import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';
import { Colors, Fonts, Radii, Spacing, Typography } from '../constants';
import { Button } from './Button';

interface EmptyStateNoClubsProps {
  navigation: any;
}

/**
 * Full-screen empty state for members who haven't joined a club yet
 * (design v2): 96px accent-soft circle with a 40px accent-strong glyph, Lora
 * title, 15px green body, primary "Find your club" button.
 */
export const EmptyStateNoClubs: React.FC<EmptyStateNoClubsProps> = ({ navigation }) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <View style={styles.iconCircle}>
        <Ionicons name="people" size={40} color={Colors.accentStrong} />
      </View>
      <Text style={[Typography.section, styles.title]}>
        {t('components.emptyStateNoClubs.title')}
      </Text>
      <Text style={styles.subtitle}>{t('components.emptyStateNoClubs.subtitle')}</Text>
      <Button
        title={t('components.emptyStateNoClubs.button')}
        icon="search-outline"
        onPress={() => navigation.navigate('Clubs')}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: Spacing['4xl'],
    paddingHorizontal: Spacing.xl,
    backgroundColor: Colors.white,
  },
  iconCircle: {
    width: 88,
    height: 88,
    borderRadius: Radii.card,
    backgroundColor: Colors.primaryLight,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: Spacing.lg,
  },
  title: {
    color: Colors.textDark,
    textAlign: 'center',
    marginBottom: Spacing.sm,
  },
  subtitle: {
    fontFamily: Fonts.regular,
    fontSize: 15,
    lineHeight: 23,
    color: Colors.textMedium,
    textAlign: 'center',
    maxWidth: 360,
    marginBottom: Spacing.xl,
  },
});
